import { render, staticRenderFns } from "./PayrollOverviewsActions.vue?vue&type=template&id=0b2ed9dc&scoped=true&"
import script from "./PayrollOverviewsActions.vue?vue&type=script&lang=js&"
export * from "./PayrollOverviewsActions.vue?vue&type=script&lang=js&"
import style0 from "./PayrollOverviewsActions.vue?vue&type=style&index=0&id=0b2ed9dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ed9dc",
  null
  
)

export default component.exports